module.exports = __webpack_public_path__ + "img/gift.27c12c5f.png";